"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUrl = void 0;
function buildUrl(baseUrl, queryParams = {}) {
    const url = new URL(baseUrl);
    for (let [key, value] of Object.entries(queryParams)) {
        if (typeof value != "string") {
            value = JSON.stringify(value);
        }
        url.searchParams.set(key, value);
    }
    return url;
}
exports.buildUrl = buildUrl;
//# sourceMappingURL=url.js.map